<template>
  <header class="site-header app group">
    <div class="row expanded">
      <div class="columns">
        <a 
          href="//www.phila.gov/employee-screener/" 
          class="logo"
        >
          <img 
            src="//www.phila.gov/media/logo/city-of-philadelphia.svg" 
            alt="City of Philadelphia logo"
            class="desktop"
          >
        </a>
        <div class="app-divide desktop" />
        <div class="page-title-container">
          <a href="/employee-screener/">
            <h1 class="page-title">{{ appTitle }}</h1>
            <p class="page-subtitle">CITY OF PHILADELPHIA</p>
          </a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    appTitle: {
      type: String,
      required: true,
    },
  },
};
</script>
<style scoped>
  .site-header .page-title-container a h1{
    font-size: 2em;
  }
  .beta-tag {
    display: inline-block;
    font-size: 12px;
    font-weight: 800;
    vertical-align: middle;
    margin-left: 8px;
    margin-bottom: 5px;
    padding: 1px;
    padding-left: 6px;
    padding-right: 6px;
    border-radius: 1px;
    color: #000;
    background: #ff8d00;
    text-transform: uppercase;
  }
</style>
